var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-container"},[_c('el-row',[_c('HeadBar')],1),_c('el-row',[_c('SubNav')],1),_c('div',{staticClass:"content-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('router-view',{ref:"page-body"})],1)])]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }